module.exports = __webpack_public_path__ + "img/hot-tub-person.c02d9e5c.svg";